import React, { Component } from "react";
import './bespoke.css';
import Slider from "react-slick";
import { FormattedMessage } from 'react-intl';

const settings = {
  dots: true,
  infinite: true,
  arrows: false,
  speed: 2500,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  pauseOnHover: false
};

class Engagements extends Component {

  render() {
    return (
      <div>
        <div className="row bespoke-row" >
          <img className="bespoke-swirl3" src="img/bespoke/swirl-3.png" alt="Swirl" />
          <div className="col-sm-3 d-none d-sm-block bespoke-image-col">
            <img className="bespoke-image" src="img/bespoke/bespoke-top-1.jpg" alt="Bespoke top 1" />
          </div>
          <div className="col-sm-3 d-none d-sm-block bespoke-image-col">
            <img className="bespoke-image" src="img/bespoke/bespoke-top-2.jpg" alt="Bespoke top 2" />
          </div>
          <div className="col-sm-3 d-none d-sm-block bespoke-image-col">
            <img className="bespoke-image" src="img/bespoke/bespoke-top-3.jpg" alt="Bespoke top 3" />
          </div>
          <div className="col-sm-3 d-none d-sm-block bespoke-image-col">
            <img className="bespoke-image" src="img/bespoke/bespoke-top-4.jpg" alt="Bespoke top 4" />
          </div>
          <div className="col-sm-3 d-block d-sm-none bespoke-image-col">
            <Slider className="bespoke-slider"  {...settings}>
              <div>
            <img className="bespoke-image" src="img/bespoke/bespoke-top-1.jpg" alt="Bespoke top 1" />
              </div>
              <div>
            <img className="bespoke-image" src="img/bespoke/bespoke-top-2.jpg" alt="Bespoke top 2" />
              </div>
              <div>
            <img className="bespoke-image" src="img/bespoke/bespoke-top-3.jpg" alt="Bespoke top 3" />
              </div>
              <div>
            <img className="bespoke-image" src="img/bespoke/bespoke-top-4.jpg" alt="Bespoke top 4" />
              </div>
            </Slider>
          </div>
        </div>

        <div className="row bespoke-inner-row" >
          <div className="col-sm-3">
          </div>
          <div className="col-sm-6 bespoke-text-col-top">
            <h1 className="bespoke-title">
              <span className="bespoke-title-capital"><FormattedMessage id={'bespoke.capital'} /></span>
              <span className="bespoke-title-text"><FormattedMessage id={'bespoke.title'} /></span>
            </h1>
            <p className="bespoke-text" ><FormattedMessage id={'bespoke.text1'} /></p>
          </div>
          <div className="col-sm-3">
          </div>
        </div>
        <div className="row bespoke-inner-row" >
          <div className="col-sm-2">
          </div>
          <div className="col-sm-8">
            <img className="bespoke-image-sketch" src="img/bespoke/bespoke-sketch.png" alt="Sketchces" />
          </div>
          <div className="col-sm-1">
          </div>
        </div>
        <div className="row bespoke-text-row" >
          <img className="bespoke-swirl4" src="img/bespoke/swirl-4.png" alt="Swirl" />
          <div className="col-sm-3">
          </div>
          <div className="col-sm-6 bespoke-text-col-bottom">
            <p className="bespoke-text" ><FormattedMessage id={'bespoke.text2'} /></p>
            <img className="bespoke-swirl" src="img/bespoke/bespokeswirl.svg" alt="Swirl" />
            <p className="bespoke-text" ><FormattedMessage id={'bespoke.text3'} /></p>
            <p className="bespoke-text" ><FormattedMessage id={'bespoke.text4'} /></p>
          </div>
          <div className="col-sm-3">
          </div>
        </div>


        <div className="row bespoke-bottom-row" >
          <div className="col-sm-3 d-none d-sm-block bespoke-image-col">
            <img className="bespoke-image" src="img/bespoke/bespoke-bottom-1.gif" alt="Bespoke bottom center" />
          </div>
          <div className="col-sm-6 d-none d-sm-block bespoke-image-col bespoke-image-col-wide">
            <img className="bespoke-image" src="img/bespoke/bespoke-bottom-2.jpg" alt="Bespoke bottom center" />
          </div>
          <div className="col-sm-3 bespoke-image-col">
            <img className="bespoke-image" src="img/bespoke/bespoke-bottom-3.gif" alt="Bespoke bottom center" />
          </div>
        </div>
      </div>
    );
  }
}

export default Engagements;



// WEBPACK FOOTER //
// ./src/bespoke/bespoke.js